import { FlowRouteCategory } from '@eneco/flows/types';

import { CustomerDetailsStepWithHighlights } from '../../../shared/steps';
import { TestConfigVariant } from '../../types/experiment';

/**
 * A/B test exp-n-477: single-page customer details.
 *
 * Variant C is variant B (the combined step) plus a reassurance side panel,
 * laid out in two columns. Variant A is the untouched production flow (the
 * two-step version); variant B is the centered single-column combined step.
 *
 * Like variant B, the combined step reuses the `PERSONAL_DETAILS` route in place
 * — same id and same path, only the component changes — so the summary "edit
 * personal details" action keeps resolving and the route still maps to the
 * existing Sitecore page for its navigation chrome. Only CONTACT_DETAILS is
 * removed, as its fields now live in the combined step.
 */
export const exp_n_477_C: TestConfigVariant = {
  testKey: 'exp-n-477-personal-details-consolidation',
  variant: 'C',
  routes: [
    {
      id: 'PERSONAL_DETAILS',
      path: '/je-gegevens/persoonlijke-gegevens/',
      category: FlowRouteCategory.Details,
      component: CustomerDetailsStepWithHighlights,
    },
  ],
  removeRouteIds: ['CONTACT_DETAILS'],
};
